var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeavyCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 22.5112C17.5753 22.5112 22.5 17.5865 22.5 11.5112C22.5 5.43593 17.5753 0.51123 11.5 0.51123C5.4247 0.51123 0.5 5.43593 0.5 11.5112C0.5 17.5865 5.4247 22.5112 11.5 22.5112Z",
    fill: "#A9CF3D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.52148 12.2235L9.3661 15.0681L16.4776 7.95654",
    stroke: "white",
    strokeWidth: 1.69231,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeavyCheck);
export default __webpack_public_path__ + "static/media/heavy-check.0799407eee375cd5ceb572ab4d987b5f.svg";
export { ForwardRef as ReactComponent };